<template>
  <v-data-table
    :headers="headers"
    :items="formattedItems"
    :loading="loading"
    must-sort
    :no-data-text="$t('texts.activeApplicationsTablePlaceholder')"
    :no-results-text="$t('texts.noActiveApplications')"
    class="elevation-0"
    :hide-default-footer="formattedItems.length <= 5 || loading"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip color="info" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon class="mx-0"
            @click="showPdfDialog({
              id: item.id,
              status: item.status,
              title: `${item.job} - ${item.formattedName}`,
              pdfLink: item.application_pdf
            })">
            <v-icon color="primary">insert_drive_file</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.showApplication') }}</span>
      </v-tooltip>
      <v-tooltip color="info" top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon class="mx-0"
            @click="showEditApplicationDialog(item)"
          >
            <v-icon color="primary">edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.edit') }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapCompanyApplicationsState,
  mapActions: mapCompanyApplicationsActions,
} = createNamespacedHelpers('company/applications');

export default {
  name: 'TableApplications',
  props: {
    loading: {
      type: Boolean,
    },
    items: {
      type: Array,
    },
  },
  computed: {
    ...mapCompanyApplicationsState(['updateApplicationPending']),
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
    headers() {
      const headers = [
        {
          text: this.$i18n.t('texts.applicants'),
          value: 'formattedName',
          align: 'left',
        },
        { text: this.$i18n.t('texts.workplace'), value: 'job', align: 'left' },
        { text: this.$i18n.t('texts.status'), value: 'formattedStatus', align: 'left' },
        { text: '', value: 'actions', align: 'right' },
      ];
      return headers;
    },
    formattedItems() {
      if (this.items.length > 0) {
        return this.items.map((item) => {
          const formattedName = `${item.employee_first_name} ${item.employee_last_name}`;
          const formattedStatus = this.$i18n.t(`texts.applicationStatus.${item.status}`);
          const formattedItem = {
            ...item,
            formattedName,
            formattedStatus,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    ...mapCompanyApplicationsActions(['updateApplication']),
    showEditApplicationDialog(item) {
      this.$eventBus.$emit('show-edit-application-dialog', item);
    },
    showPdfDialog(item) {
      if (item.status === 'SENT') {
        const payload = {
          id: item.id,
          companyId: this.selectedCompanyId,
          values: {
            status: 'READ',
          },
        };
        this.updateApplication(payload).then(() => {
          this.$eventBus.$emit('show-pdf-dialog', item);
        });
      } else {
        this.$eventBus.$emit('show-pdf-dialog', item);
      }
    },
  },
};
</script>
